// Per primo: libera la localStorage dagli avatar enormi prima che parta Firestore.
import './services/avatarStore.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { API_BASE } from './services/apiBase.js';
import { initTheme } from './services/themeService.js';
import { initPwaUpdates } from './services/pwaUpdate.js';

initTheme();
initPwaUpdates();

const originalFetch = window.fetch;
window.fetch = async (input, init) => {
    if (API_BASE && typeof input === 'string' && input.startsWith('/api/')) {
        input = API_BASE + input;
    }
    return originalFetch(input, init);
};

const root = createRoot(document.getElementById('root'));

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
